import React from "react";
import { GiFairyWings } from "react-icons/gi";
import { Helmet } from "react-helmet-async";
import "./IdealHistory.css";

// Import your history image
import historyImg from "../../../assets/home/onkar-singh.jpg";

const IdealHistory = () => {
  return (
    <>
      <Helmet>
        <title>Ideal History | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Learn about the ideal history and mission of Rajput Shiksha Kosh."
        />
      </Helmet>

      <section className="ideal-history-of-rajput-shiksha-kosh-wrapper">
        <div className="ideal-history-of-rajput-shiksha-kosh-container">
          {/* --- 1. HEADER (Title + Divider) --- */}
          <div className="ideal-history-of-rajput-shiksha-kosh-header">
            <h2 className="ideal-history-of-rajput-shiksha-kosh-title">
              HISTORY OF RAJPUT SHIKSHA KOSH
            </h2>
            <div className="ideal-history-of-rajput-shiksha-kosh-divider">
              <span className="ideal-history-of-rajput-shiksha-kosh-line"></span>
              <GiFairyWings className="ideal-history-of-rajput-shiksha-kosh-icon" />
              <span className="ideal-history-of-rajput-shiksha-kosh-line"></span>
            </div>
          </div>

          {/* --- 2. SMALL CENTERED IMAGE (Outside the main box) --- */}
          <div className="ideal-history-of-rajput-shiksha-kosh-img-outer-box">
            <img
              src={historyImg}
              alt="Rajput Shiksha Kosh History"
              className="ideal-history-of-rajput-shiksha-kosh-small-img"
            />
          </div>

          {/* --- 4. MAIN CONTENT DIV (White Background, No Top Border) --- */}
          <div className="ideal-history-of-rajput-shiksha-kosh-content-card">
            {/* --- 3. SUBTITLE LINE --- */}
            <h3 className="ideal-history-of-rajput-shiksha-kosh-sub-heading-line">
              Ideal of Rajput Shiksha Kosh
            </h3>
            <p className="ideal-history-of-rajput-shiksha-kosh-salutation">
              आदरणीय बन्धु,
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-paragraph">
              यह एक विशेष प्रकल्प की सफलता पूर्वक परिणिति में आपकी भागीदारी को
              अनिवार्य रूप से सुनिशिचत करने की कामना से लिख रहा हु।
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-paragraph">
              समाज के हमारे भाइयो के आर्थिक पिछड़ेपन से आप भलीभांति परिचित है।
              राजपूत समाज की 70 प्रतिशत आबादी आज भी गरीबी रेखा से नीचे जीवन यापन
              करने को विवश है। इतनी विषम परिस्थितियों में भी इन अभावग्रस्त
              राजपूत भाइयो के परिवारों में अनेकों बच्चे बहुत ही प्रतिभावान एंव
              होनहार है। इन्ही गुदडी के लाल बाल प्रतिभाओ को शिक्षा दान देकर उनके
              भविष्य को सवारने हेतु एक सार्थक प्रयास होना आवश्यक है।
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-paragraph">
              <strong>ठाकुर ओंकार सिंह जी बाबरा आई.ए.एस (रिटा.)</strong> ने
              आभावग्रस्त प्रतिभावान छात्रों की शिक्षा व्यवस्था हेतु नियमित रूप
              से छात्रवृति प्रदान की जा सके इसके लिए{" "}
              <strong>१० करोड़ के स्थाई कोष</strong> के गठन का प्रस्ताव रखा एंव
              इसकी स्थापना हेतु अपनी तरफ से <strong>५ लाख</strong> का अंशदान भी
              प्रदान कर दिया।
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-paragraph">
              इस अत्यंत ही महत्वपूर्ण प्रस्ताव पर तत्काल की कार्यवाही शुरू कर दी
              गई तथा जुलाई 2017 से 10 प्रतिभावान जरूरतमंद छात्रों को{" "}
              <strong>06,02,000/-</strong> की छात्रवर्तीया प्रदान क्र दी गई है।
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-paragraph">
              इस अभूतपूर्व विचार एंव कार्य के अनुसार अभावग्रस्त- प्रतिभावान
              बालको को शिक्षा दान देने की दीर्घ कालीन, निरंतर एंव नियमित
              व्यवस्था हो इस हेतु राजपूत शिक्षा कोष नामक ट्रस्ट का गठन किया जा
              चूका है। इस हेतु 10 करोड़ रूपये का स्थाई कोष बनाने का समाज ने
              संकल्प लिया है। इस संकल्प पूर्ति का दायित्व हम सब का है।
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-paragraph">
              चूँकि हमारा लक्ष्य 10 करोड़ रूपये इकट्ठे करना है, हमने आजीवन लाखो
              कमाए है लाखो खर्च भी किये है। एक शाम की पार्टी में हजारो एंव विशेष
              आयोजन में लाखो ख़ुशी-ख़ुशी खर्च भी करते है, हमारा निवदेन है इस समाज
              हितार्थ सुकार्य में उदारता से अंशदान देने की कृपा करे। हमारा
              निवेदन है की आपका यह अर्थ सहयोग one time सहयोग राशि के रूप में हो।
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-paragraph">
              हम आपको पूर्ण विश्वास दिलाते है की इस स्थाई कोष से एक पैसा किसी भी
              परिस्थिति में नहीं निकला जायेगा और इस फण्ड के ब्याज/लाभांश से ही
              छात्रवृतिया अथवा education loan दिये जायेंगे। इस हेतु आपका यह अर्थ
              सहयोग है, ऐच्छिक नहीं। आपको यह सहयोग राशि भेजनी ही होगी चाहे वह
              रकम 100/- रु. से लेकर आप की श्रद्धानुसार हो सकता है।
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-paragraph">
              यह राशि चेक/ड्राफ्ट अथवा RTGS/NEFT के जरिए लाभांश से हजारो बालको
              की शिक्षा व्यवस्था में काम आएगा। कृपया पूर्ण शक्ति एंव श्रद्धा के
              साथ प्रदान करे। इसे हमारा दुराग्रह नहीं माना जावे यह तो हमारी
              विनयपूर्वक प्रार्थना है। क्योकि आप प्रभु की असीम कृप्या से सक्षम
              एंव सम्पन है। आप समाज के उन्नयन के पक्षधर है। आप शिक्षा के महत्व
              को जानते है।
            </p>

            <p className="ideal-history-of-rajput-shiksha-kosh-blessing">
              माँ भगवती आपको सुख, सम्पति एंव समृद्धि प्रदान करे।
            </p>

            {/* --- SIGNATURE --- */}
            <div className="ideal-history-of-rajput-shiksha-kosh-footer-sig">
              <h4>डॉ. नारायण सिंह माणकलाव</h4>
              <p>(पदम्श्री, पदम् भूषण एंव पूर्व सांसद)</p>
              <p>संपर्क: 9414133996</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IdealHistory;
